<template>
  <div
    class="cs-fab"
    @mouseenter="openPanel"
    @mouseleave="closePanel"
  >
    <button
      type="button"
      class="cs-trigger"
      aria-label="联系客服"
      @click="togglePanel"
    >
      <i class="el-icon-service"></i>
    </button>

    <div v-show="panelVisible" class="cs-panel" @click.stop>
      <div class="cs-panel-header">
        <div class="cs-panel-title">联系客服</div>
        <div class="cs-panel-desc">扫码添加企业微信，在线咨询</div>
      </div>
      <div class="cs-panel-qr">
        <img :src="qrCodeUrl" alt="客服二维码" @error="onQrError">
      </div>
      <div class="cs-panel-tip">工作时间：周一至周五 9:00 - 18:00</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { defaultSiteConfig } from '@/utils/site'

const DEFAULT_QR = '/web_img/footer/gzh.webp'

export default {
  name: 'CustomerServiceFab',
  data() {
    return {
      panelVisible: false,
      isTouchDevice: false,
      qrCodeUrl: DEFAULT_QR,
      qrFallbackUsed: false
    }
  },
  computed: {
    ...mapGetters(['siteConfig']),
    fallbackQr() {
      const cfg = this.siteConfig || defaultSiteConfig
      return cfg.gzhImage || defaultSiteConfig.gzhImage
    }
  },
  mounted() {
    this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    openPanel() {
      if (!this.isTouchDevice) {
        this.panelVisible = true
      }
    },
    closePanel() {
      if (!this.isTouchDevice) {
        this.panelVisible = false
      }
    },
    togglePanel() {
      if (this.isTouchDevice) {
        this.panelVisible = !this.panelVisible
      }
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.panelVisible = false
      }
    },
    onQrError() {
      if (!this.qrFallbackUsed) {
        this.qrFallbackUsed = true
        this.qrCodeUrl = this.fallbackQr
      }
    }
  }
}
</script>

<style scoped>
/* 容器尺寸固定为按钮大小，弹窗绝对定位，避免弹出时图标位移 */
.cs-fab {
  position: fixed;
  right: 20px;
  top: 78%;
  width: 52px;
  height: 52px;
  margin-top: -26px;
  z-index: 1900;
}

.cs-trigger {
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #409EFF 0%, #1677ff 100%);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(22, 119, 255, 0.35);
  position: relative;
  z-index: 2;
}

.cs-trigger i {
  font-size: 22px;
}

.cs-panel {
  position: absolute;
  right: 0;
  bottom: calc(100% + 10px);
  width: 220px;
  padding: 16px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e8eef5;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.12);
  text-align: center;
  z-index: 1;
}

/* 填充按钮与弹窗之间的空隙，避免鼠标移入时闪烁关闭 */
.cs-panel::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  height: 14px;
}

.cs-panel-header {
  margin-bottom: 12px;
}

.cs-panel-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.cs-panel-desc {
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.5;
}

.cs-panel-qr {
  padding: 10px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fbff 0%, #fff 100%);
  border: 1px solid #dbeafe;
}

.cs-panel-qr img {
  display: block;
  width: 160px;
  height: 160px;
  margin: 0 auto;
  border-radius: 8px;
  object-fit: cover;
}

.cs-panel-tip {
  margin-top: 10px;
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.4;
}

@media screen and (max-width: 767px) {
  .cs-fab {
    top: auto;
    margin-top: 0;
    width: 48px;
    height: 48px;
  }

  .cs-trigger {
    width: 48px;
    height: 48px;
  }

  .cs-trigger i {
    font-size: 20px;
  }
}
</style>
